<!--送培第一步 报名人员信息-->
<template>
  <div class="gray-back" style="padding:.2rem 0 1rem 0">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">

      <van-form
          @submit="onSubmit"
          @failed="onFailed"
          style="min-height: 90vh;"
      >
        <div v-for="(member,index) in row.member_list" :key="index">
          <van-divider>人员信息{{ index + 1 }}
          </van-divider>
          <van-cell-group>
            <van-cell
                readonly
                input-align="right"
                :title="'人员'+(index+1)"
                :label="member.num"
                :value="member.name"
            >
              <template #right-icon>
                <van-icon @click="memberRemove(member,index)" name="close" style="margin-top: 5px ; margin-left: 10px"/>
              </template>
            </van-cell>

            <van-field
                name="radio" label="性别"
                input-align="right">
              <template #input>
                <van-radio-group v-model="member.sex" direction="horizontal">
                  <van-radio checked-color="#ffb01b" name="男">男</van-radio>
                  <van-radio checked-color="#ffb01b" name="女">女</van-radio>
                </van-radio-group>
              </template>
            </van-field>


            <van-field
                v-model="member.weixin"
                :rules="[{ required: true,message:'请输入微信号'}]"
                error-message-align="right"
                label="微信号"
                input-align="right"
                clearable
                placeholder="请输入微信号"
            />

            <van-field
                v-model="member.phone"
                :rules="[{ required: true,message:'请输入正确的手机号'}]"
                error-message-align="right"
                label="手机"
                input-align="right"
                clearable
                placeholder="请输入手机"
            />
            <!--                  <van-field-->
            <!--                      v-model="member.csize"-->
            <!--                      error-message-align="right"-->
            <!--                      v-show="row.gametype == 3"-->
            <!--                      clearable-->
            <!--                      @click-left-icon="cSizeShow = true"-->
            <!--                      :rules="[]"-->
            <!--                      label="衣服尺码"-->
            <!--                      placeholder="请输入尺码"-->
            <!--                      input-align="right"-->
            <!--                  />-->
            <!--                  <van-field-->
            <!--                      v-model="member.footsize"-->
            <!--                      clearable-->
            <!--                      :rules="[]"-->
            <!--                      error-message-align="right"-->
            <!--                      label="鞋  码"-->
            <!--                      v-show="row.gametype == 3"-->
            <!--                      @click-left-icon="fSizeShow = true"-->
            <!--                      placeholder="请输入鞋码"-->
            <!--                      input-align="right"-->
            <!--                  />-->
            <van-cell center title="是否参加能力测试" v-show="row.gametype == 3">
              <template #right-icon>
                <van-switch v-model="member.is_join_exame" active-color="#ffad19" :active-value="1" :inactive-value="2"
                            size="24"/>
              </template>
            </van-cell>
            <!--                  <div @click="cSizeShow=true" class="operate-desc-left" v-if="formData.pay_status==2">查看衣服尺码表</div>-->
            <!--                  <div @click="fSizeShow=true" class="operate-desc-left" v-if="formData.pay_status==2">查看鞋码表,已付款禁止修改 </div>-->
            <!--                  <div @click="fSizeShow=true" class="operate-desc-left" v-else >查看鞋码表</div>-->
            <van-field
                v-show="row.gametype == 3"
                v-model="member.join_exame_name"
                error-message-align="right"
                label="技术等级测试项目"
                input-align="right"
                clearable
                placeholder="请输入技术等级测试项目"
            />
            <div class="operate-desc-left" v-show="row.gametype == 3">技巧/花球/街舞/爵士</div>
<!--            <van-field-->
<!--                readonly-->
<!--                clickable-->
<!--                right-icon="arrow"-->
<!--                input-align="right"-->
<!--                @click="thisMemberIndex = index;showServiceTypePicker=true"-->
<!--                label="服务套餐"-->
<!--                v-model="member.serviceName"-->
<!--            />-->

            <div v-for="(field,fileindex) in row.extra_field"
                 :key="fileindex">
              <van-field
                  v-model="member.jsondata[field.label]"
                  :rules="[{ required: field.required,message:'请输入'+field.label}]"
                  error-message-align="right"
                  :label="field.label"
                  input-align="right"
                  clearable
                  :placeholder="'请输入'+field.label"
              />
              <div v-show="field.desc" class="operate-desc-left">{{ field.desc }}</div>
            </div>
          </van-cell-group>
        </div>


        <div style="text-align: center">
          <van-button
              native-type="button"
              style="width: 3rem; margin-top: 0.4rem"
              size="normal" round icon="plus" @click="onMemberAdd">新增人员
          </van-button>
        </div>

        <div style="height: 100px"></div>

        <div class="savebtn">
          <van-button
              style="width: 3rem"
              size="normal" round @click="goPre()" native-type="button">上一步
          </van-button>
          <van-button
              color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
              style="width: 3rem"
              size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">
            保存
          </van-button>
        </div>
      </van-form>
    </van-pull-refresh>
    <van-button
        v-if="row.gametype == 3"
        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
        style="
    bottom: 80px;
    right: 10px;
    z-index: 10;
    position: fixed;"
        size="normal" round
        round @click.native="showTemplate = true">导入模板
    </van-button>

<!--    <van-popup v-model="showServiceTypePicker" v-if="row.member_list.length>0" position="bottom">-->
<!--      <van-picker :columns="serviceTypeColumns"-->
<!--                  show-toolbar-->
<!--                  :default-index="row.member_list[thisMemberIndex].serviceType-1"-->
<!--                  @cancel="showServiceTypePicker = false"-->
<!--                  @confirm="onServiceConfirm"-->
<!--      />-->
<!--    </van-popup>-->

    <van-popup
        position="bottom"
        :style="{ height: '50%' }"
        v-model="addShow"
        @click-overlay="addShow=false"
    >
      <div style="margin-top: 0.2rem ; margin-bottom: 1.5rem">
        <van-form
            @submit="onMemberSubmit"
            @failed="onFailed"
        >
          <van-divider>新增人员</van-divider>
          <van-cell-group>
            <van-field
                v-model="formData.name"
                label="姓名"
                :rules="[{ required: true, message: '姓名不能为空' }]"
                error-message-align="right"
                input-align="right"
                clearable
                placeholder="请输入姓名"
            />
            <van-field
                readonly
                clickable
                right-icon="arrow"
                input-align="right"
                @click="showNumTypePicker=true"
                label="证件类型"
                v-model="formData.numTypeName"
            />
            <van-popup v-model="showNumTypePicker" position="bottom">
              <van-picker :columns="numTypeColumns"
                          show-toolbar
                          :default-index="formData.cardtype-1"
                          @cancel="showNumTypePicker = false"
                          @confirm="onNumTypeConfirm"
              />
            </van-popup>


            <van-field
                v-if="formData.cardtype==1"
                v-model="formData.num"
                :rules="[{ validator: validator.idCard,message:'请输入正确的身份证号'}]"
                error-message-align="right"
                label="身份证号"
                input-align="right"
                clearable
                placeholder="请输入身份证号"
            />

            <van-field
                v-model="formData.huzhao"
                v-if="formData.cardtype!=1"
                label="证件号码"
                :rules="[{ required: true, message: '证件号码不能为空' }]"
                error-message-align="right"
                input-align="right"
                clearable
                placeholder="请输入证件号码"
            />


          </van-cell-group>

          <div class="savebtn">
            <van-button
                color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                style="width: 3rem"
                size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..."
                native-type="submit">确定
            </van-button>
          </div>
        </van-form>
      </div>
    </van-popup>

    <van-dialog v-model="cSizeShow" title="衣服尺码表">
      <img @click="picShow(key,cSizePicList)" v-for="(pic,key) in cSizePicList" :src="pic" style="width: 100%"/>
    </van-dialog>
    <van-dialog v-model="fSizeShow" title="鞋码表">
      <p style="padding: 10px; text-align: center">此鞋型偏小，建议选大一码</p>
      <img :src="fSizePicList[0]" @click="picShow(0,fSizePicList)" style="width: 100%"/>
    </van-dialog>
    <van-dialog v-model="showTemplate" title="导入模板信息">
      <div class="operate-desc-left">复制下面的链接，用电脑端打开，进行批量导入操作</div>
      <!--      <div class="operate-desc-left" @click="download" style="color: #1989fa;">考级人员批量导入模版下载</div>-->
      <div class="operate-desc-left" v-clipboard:copy="row.share"
           v-clipboard:success="onCopy"
           v-clipboard:error="onError" style="color: #666">导入模板链接地址：{{ row.share }}
        <div class="small-button">复制</div>
      </div>
      <!--        <div class="operate-desc-left" @click="download" style="color: #1989fa;">训练营报名批量导入模版下载</div>-->
    </van-dialog>

  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}

.small-button {
  height: 30px;
  padding: 0 8px;
  font-size: 12px;
  line-height: 30px;
  color: #323233;
  background-color: #fff;
  border: 1px solid #ebedf0;
  display: inline-block;
}

.memberResultWrap {
  background: #F3F3F3;
  margin: 0.2rem;
  border-radius: 8px;
  padding: 0.2rem;
}

.memberResultWrap .memberLi {
  font-size: 14px;
  color: #666;
  height: 36px;
  line-height: 36px;
}

.memberResultWrap .memberLi .van-tag {
  width: auto !important;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}

</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import FileUploader from '@/components/picker/FileUploader.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Dialog,
  ActionSheet,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button,
  ImagePreview
} from 'vant';

import SubjectJiaolianPicker from '@/components/picker/SubjectJiaolianPicker.vue';
import YundongyuanPicker from '@/components/picker/YundongyuanPicker.vue';


Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(ActionSheet).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button).use(Dialog);
export default {
  name: 'SongpeiApplyFormStep1',
  components: {
    [Field.name]: Field,
    PicUploader,
    FileUploader,
  },
  data: function () {
    return {
      validator,
      playMusicUrl: '',
      thisMemberIndex: 0,
      saveLoading: false,
      isLoading: false,
      showNumTypePicker: false,
      showServiceTypePicker: false,
      addShow: false,
      show_share_panel: false,
      numTypeColumns: ['身份证', '护照'],
      showArea: false,
      showTemplate: false,
      areaList: {},
      thismember: {},
      copy_text: 'cccc',
      areaValue: '',
      submitType: '',
      subject_name: '',
      subjectArray: [],
      row: {
        id: 0,
        member_list: [],
        service_options: [],
        extra_field: [],
      },
      formData: {
        name: '',
        num: '',
        cardtype: 1,
        footsize: '',
        csize: '',
        is_join_exame: 2,
        join_exame_name: '',
        numTypeName: '身份证',
      },

      fSizeShow: false,
      cSizeShow: false,
      cSizePicList: ['https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20200906/user-1/20200906/7fd2e382afe6f9bd49b3ce9a8ae37a24.png', 'https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20200906/user-1/20200906/8fb609af0a199bea84da2ff641aacf1f.png'],
      fSizePicList: ['https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20200906/user-1/20200906/33e31ebf9997638013aacb02ed5eeb41.png'],
    }
  },
  filters: {},
  mounted() {
    document.title = '信息补充';

    let that = this;
    that.areaList = area;
    that.row.id = this.$route.query.id;
    if (that.row.id) {
      this.fetch();
    }
  },
  watch: {
    formData() {
    }
  },
  computed: {
    // serviceTypeColumns() {
    //   return this.row.member_list[this.thisMemberIndex].service_options.map(item => {
    //     return item.name + '(¥' + item.price + ')';
    //   })
    // }

  },
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log('onQuestion')
    },

    onRefresh() {
      setTimeout(() => {
        Toast('刷新成功');
        this.fetch()
      }, 800);
    },

    onMemberAdd() {
      this.addShow = true;
      this.formData = {
        name: '',
        num: '',
        cardtype: 1,
        footsize: '',
        csize: '',
        is_join_exame: 2,
        join_exame_name: '',
        numTypeName: '身份证',
      };
    },
    memberRemove(item, index) {
      let that = this;
      let notice = '确认删除' + item.name + '(' + item.num + ')' + '吗?';
      Dialog.confirm({
        title: '确认',
        message: notice
      })
          .then(() => {
            // on confirm
            console.log('subjectRemove');
            if (!item.id) {
              that.row.member_list.splice(index, 1);
              return
            }
            that.$api.post('/api/songpei/memberDelete', {
              'baoming_id': that.row.id,
              'member_id': item.id
            }, (res) => {
              that.row.member_list.splice(index, 1);
            }, (res) => {
              Toast.fail(res.msg);
            })

          })
          .catch(() => {
            // on cancel
          });
    },
    onNumTypeConfirm(value, index) {
      this.formData.numTypeName = value;
      this.formData.cardtype = index + 1;
      this.showNumTypePicker = false;
    },
    onServiceConfirm(value, index) {
      this.row.member_list[this.thisMemberIndex].serviceName = value;
      this.row.member_list[this.thisMemberIndex].serviceType = index + 1;
      this.showServiceTypePicker = false;
    },
    onMemberSubmit(values) {
      console.log('onMemberSubmit-values', values);
      console.log('onMemberSubmitsubmitType', this.submitType);
      console.log('formData', this.formData);


      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      for (let field in that.formData) {

      }
      that.saveLoading = true;

      that.$api.post('/api/songpei/checkApplyNameNum', {
        name: that.formData.name,
        num: that.formData.num,
        numtype: that.formData.cardtype,
        baoming_id: that.row.id
      }, (res) => {
        that.saveLoading = false;
        let sex = '';
        if (this.formData.cardtype == 1) {
          if (this.formData.num.substr(17, 1) % 2 == 0) {
            sex = '男';
          } else {
            sex = '女';
          }
        }

        let jsondata = {};
        if(that.row.extra_field && that.row.extra_field.length > 0) {
          this.row.extra_field.map((field, findex) => {
            jsondata[field.label] = '';
          });
        }

        this.row.member_list.push({
          name: this.formData.name,
          num: this.formData.cardtype == 1 ? this.formData.num : this.formData.huzhao,
          user_id: this.row.user_id,
          baoming_id: this.row.id,
          // service_options: res.data.service_options,
          sex: sex,
          jsondata: jsondata,
        })
        this.addShow = false;

      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })


    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;
      let valiOk = true;

      if (that.row.member_list.length == 0) {
        Toast('请至少新增一个人员');
        return;
      }
      console.log(that.row.member_list)
      that.row.member_list.map((item, index) => {
        if (!item.sex) {
          Toast('请选择人员' + (index + 1) + '的性别');
          valiOk = false;
          return;
        }
        // if (!item.serviceName) {
        //   Toast('请选择人员' + (index + 1) + '的服务套餐');
        //   valiOk = false;
        //   return;
        // }
      });
      if (!valiOk) {
        return;
      }


      that.saveLoading = true;

      that.$api.post('/api/songpei/membersave', {
        'baoming_id': that.row.id,
        'member_list': that.row.member_list.map(item => {
          return {
            'id': item.id || 0,
            'name': item.name,
            'num': item.num,
            'danwei': this.row.danwei,
            'sex': item.sex,
            'phone': item.phone,
            'weixin': item.weixin,
            'jsondata': item.jsondata,
            // 'footsize': item.footsize,
            // 'csize': item.csize,
            // 'is_join_exame': item.is_join_exame,
            // 'join_exame_name': item.join_exame_name,
            // 'service_id': this.row.member_list[this.thisMemberIndex].service_options[item.serviceType - 1].id,
            // 'price': this.row.member_list[this.thisMemberIndex].service_options[item.serviceType - 1].price
          }
        })
      }, (res) => {

        // if (that.row.next_gjsb) {
        //   rbLink({
        //     name: 'HuiyiApplyFormStep3',
        //     query: {
        //       id: that.row.id
        //     }
        //   })
        // } else {
        //   rbLink({
        //     name: 'HuiyiApplyFormStep5',
        //     query: {
        //       id: that.row.id
        //     }
        //   })
        //
        // }
        rbLink({
          name:"SongpeiApplyFormSuccess",
          query:{
            id:res.data.id
          }
        },'replace')
        that.saveLoading = false;
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },
    jumToOld(id) {
      rbLink({
        name: 'HuiyiApplyList'
      }, 'replace')
    },
    save(values) {
      this.submitType = 'save';
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    submit(values) {
      this.submitType = 'submit';
    },
    goPre() {
      let that = this;
      rbLink({
        name: 'SongpeiApplyFormBasic',
        query: {
          id: that.row.id
        }
      }, 'replace')
    },
    fetch() {
      let that = this;
      that.$api.post('/api/songpei/step1HalfDetail', {
        id: that.row.id
      }, (res) => {
        that.row = res.data;
        that.row.member_list.map(item => {
          // item.service_options.map((service, sindex) => {
          //   if (item.service_id == service.id) {
          //     that.$set(item, 'serviceType', sindex + 1);
          //     that.$set(item, 'serviceName', service.name);
          //     return;
          //   }
          // });

          that.row.extra_field.map((field, findex) => {
            if (typeof item.jsondata[field.label] == 'undefined') {
              that.$set(item.jsondata, field.label, '');
              item.jsondata[field.label] = '';
            }
          });

        })

        that.isLoading = false;

      }, (res) => {
        Toast.fail(res.msg);
      })
    },


    shareWeixinFriend() {
      console.log('shareWeixinFriend')
      let that = this;
      if (window.isApp()) {
        appEvent({
          name: 'shareWeixinFriend',
          query: that.row.share_data
        });
      } else {
        this.showWxShare = true;
        this.show_share_panel = false;
      }
    },
    shareWeixinTimeLine() {
      let that = this;
      if (window.isApp()) {
        appEvent({
          name: 'shareWeixinTimeLine',
          query: that.row.share_data
        });
      } else {
        this.showWxShare = true;
        this.show_share_panel = false;

      }
    },

    picShow(index, list) {
      ImagePreview({
        images: list,
        startPosition: index,
      });
    },

    onCopy(e) {
      Toast.success('复制成功');
    },
    onError(e) {
      console.log('复制失败！');
    },

    download() {
      appEvent({
        name: 'downloadFile',
        query: {
          name: '训练营报名批量导入表模版',
          url: 'https://ccago.oss-cn-hangzhou.aliyuncs.com/h5/2021-07-21/1626854723732285.xlsx'
        }
      });
    },

  }
}
</script>



// WEBPACK FOOTER //
// SongpeiApplyFormStep1.vue?7f434992